module.exports = __webpack_public_path__ + "static/oop_inheritance-4919720b7a062452f68738de747e5c7d.png";